import { UpdatedCwanTransaction } from './external-transaction'

export interface ExternalTransactionsActionRequest {
  actionType: ExternalActionType
  extTranRowIds: string[]
  cwTranRowIds: string[]
  updatedCwanTransaction?: UpdatedCwanTransaction // Used for match-user-external-data
}

/**
 * Constructor for ExternalTransactionsActionRequest objects
 */
export function createExternalTransactionsActionRequest(
  actionType: ExternalActionType,
  extTranRowIds: string[] = [],
  cwTranRowIds: string[] = [],
  updatedCwanTransaction?: UpdatedCwanTransaction,
): ExternalTransactionsActionRequest {
  return {
    actionType,
    extTranRowIds,
    cwTranRowIds,
    updatedCwanTransaction,
  }
}

export type ExternalTransactionsActionResponse =
  | string[]
  | ExternalTransactionValidation

export interface ExternalTransactionValidation {
  validationId: string
  message: string
}

export enum ExternalActionType {
  hold = 'hold',
  unhold = 'unhold',
  ignore = 'ignore',
  unignore = 'unignore',
  match = 'match',
  matchUsingExternal = 'matchUsingExternal',
  manyToManyMatch = 'manyToManyMatch',
  unmatch = 'unmatch',
}
